// istanbul ignore file
import React, { useEffect } from 'react'
import { type ConnectedProps, connect } from 'react-redux'
import { type RootState } from '../../../store'
import { Button } from '../../../components/Button'
import { useSelector, useDispatch } from 'react-redux'
import { type SaveDefaultViewRequest } from '../services/saveDeafultViewService'
import { saveDefaultViewDataservice } from '../redux/actionCreator'
import { SaveDefaultViewObjectUpdateAction } from '../../device-dashboard/redux/saveDefaultViewObjectSlice'
import { type SaveDefaultViewDataState } from '../redux/saveDefaultViewSlice'
import Modal from '../../../components/Modal'
import { CircularProgress } from '@mui/material'
import { getOperationPermissions } from '../../dashboard/redux/actionCreator'
import { type OperationPermissionState } from '../../dashboard/redux/operationPermissionSlice'
import { useAuth } from 'react-oidc-context'

const DeviceStatusCard = (props: AllProps): JSX.Element => {
  const dispatch = useDispatch()
  const GetSaveDefaultWidgetStatus = useSelector((state: RootState) => state.saveDefaultWidgetData)
  const saveDefaultViewObject = useSelector((state: RootState) => state.saveDefaultViewObject.saveDefaultViewObject)
  const operationPermissions: OperationPermissionState = useSelector((state: RootState) => state.operationPermissions)
  const auth = useAuth()

  console.log('saveDefaultViewObject', saveDefaultViewObject)

  useEffect(() => {
    (!operationPermissions.updated && props.getOperationPermissions(auth.user?.profile.sub as string))
  }, [])

  const defaultView = {
    assetDashBoardDefaultView: [
      {
        widgetId: 'assetAlertTrend',
        displayname: 'assetAlertTrend',
        devices: [],
        assets: []
      },
      {
        widgetId: 'assetGraph1',
        displayname: 'Graph1',
        devices: [],
        assets: []
      },
      {
        widgetId: 'assetGraph2',
        displayname: 'Graph2',
        devices: [],
        assets: []
      },
      {
        widgetId: 'assetStatus',
        displayname: 'assetStatus',
        devices: [],
        assets: []
      },
      {
        widgetId: 'assetPerformance',
        displayname: 'assetPerformance',
        devices: [],
        assets: []
      }
    ]
  }

  const handleSaveDefaulView = (): void => {
    if (saveDefaultViewObject !== null && saveDefaultViewObject !== undefined) {
      props.saveDefaultViewDataservice(props.parentAssetId, saveDefaultViewObject)
    } else if (saveDefaultViewObject === undefined || saveDefaultViewObject === null) {
      props.saveDefaultViewDataservice(props.parentAssetId, defaultView)
    }
  }

  useEffect(() => {
    if (!GetSaveDefaultWidgetStatus.isLoading) {
      dispatch(SaveDefaultViewObjectUpdateAction(null))
    }
  }, [])

  useEffect(() => {
    if (!GetSaveDefaultWidgetStatus.isLoading) {
      dispatch(SaveDefaultViewObjectUpdateAction(GetSaveDefaultWidgetStatus.DefaultWidgetData))
    }
  }, [GetSaveDefaultWidgetStatus])

  return (
    <>
    {
      operationPermissions.permissions.can_modify_tiq_intervalreadings
        ? <Button onClick={handleSaveDefaulView} className='save-default' sx={{ minWidth: '165px' }} type='hollow' width={'165px'}>{'Save Default View'}</Button>
        : null
    }
      {
        props.SaveDefaultViewData.isLoading &&
        (<Modal title={'Loading...'}>
          <div className='CircularprogressAmi'>
            <CircularProgress />
          </div>
        </Modal>)
      }
    </>
  )
}

interface StateToProps {
  SaveDefaultViewData: SaveDefaultViewDataState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  SaveDefaultViewData: state.SaveDefaultViewData
})
interface DispatchToProps {
  saveDefaultViewDataservice: (deviceId: string, requestParameter: SaveDefaultViewRequest) => void
  getOperationPermissions: (sub: string) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  saveDefaultViewDataservice: (deviceId: string, requestParameter: SaveDefaultViewRequest) => dispatch(saveDefaultViewDataservice(deviceId, requestParameter)),
  getOperationPermissions: (sub: string) => dispatch(getOperationPermissions(sub))
})

const connector = connect(mapStateToProps, mapDispatchToProps)
interface ISaveBtnProps {
  parentAssetId: string
}

type PropsFromRedux = ConnectedProps<typeof connector>
type AllProps = PropsFromRedux & ISaveBtnProps

export default connector(DeviceStatusCard)
